import React, { Component } from 'react';
import { connect } from 'react-redux';

@connect(() => {
  return {};
}, {})
export default class ModuleRoot extends Component {
  componentWillMount() {}

  render() {
    return (
      <div>
        <h1>This page does not exist</h1>
        <p>Try harder.</p>
      </div>
    );
  }
}
